let sessionPromise = null;
let sessionExpiresAt = 0;

export async function ensureDemoSession() {
  if (Date.now() < sessionExpiresAt - 60 * 1000) return;

  if (!sessionPromise) {
    sessionPromise = fetch("/.netlify/functions/demo-session", {
      method: "POST",
      credentials: "same-origin",
    })
      .then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.error || `Demo session failed: HTTP ${response.status}`);
        }
        sessionExpiresAt = Date.parse(payload.expiresAt) || Date.now() + 25 * 60 * 1000;
      })
      .finally(() => {
        sessionPromise = null;
      });
  }

  return sessionPromise;
}
